import {css, cx} from "@panda/css";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {contactBarRowButtonStyle} from "../../atoms/contact_bar/contact_bar_row_button_style";
import {RESERVATION_PLACEMENT_CONFIG} from "../constants/reservation_placement_config";
import {ReservationCtaState} from "../types/ReservationCtaState";
import {ReservationPlacement} from "../types/ReservationPlacement";
import {ReservationCtaPlaceholder} from "./ReservationCtaPlaceholder";

export type PropertyReservationCtaPlacement = Extract<ReservationPlacement, "sidebar" | "contact_bar">;

interface IProps {
    ctaState: ReservationCtaState;
    placement: PropertyReservationCtaPlacement;
    size: IButtonSizePrimary;
    fullWidth?: boolean;
    className?: string;
    onStart: () => void;
}

export const PropertyReservationCtaView = (props: IProps) => {
    const {ctaState, placement, size, fullWidth, className, onStart} = props;

    if (ctaState === "hidden") {
        return null;
    }

    const placementClassName = cx(placementStyle[placement], className);

    if (ctaState === "pending") {
        // rendered the same way on the server and on the first client render, so the slot keeps its height until availability is known
        return <ReservationCtaPlaceholder size={size} fullWidth={fullWidth} className={placementClassName} />;
    }

    if (ctaState === "reserved") {
        // not natively disabled - it is the button the reservation modal was opened from, and the focus returns to it once the modal closes
        return (
            <Button
                variant="outlined_secondary"
                type="button"
                size={size}
                fullWidth={fullWidth}
                aria-disabled="true"
                className={cx(placementClassName, reservedStyle)}
                dataTestId={RP_RESERVATION_TEST_IDS.CTA_RESERVED}
            >
                Zarezerwowane
            </Button>
        );
    }

    const {cta} = RESERVATION_PLACEMENT_CONFIG[placement];

    return (
        <Button
            variant="filled_secondary"
            type="button"
            size={size}
            fullWidth={fullWidth}
            onClick={onStart}
            className={placementClassName}
            dataTestId={cta.testId}
        >
            {cta.label}
        </Button>
    );
};

// the slot owns its spacing, because it renders nothing for most properties
const placementStyle: Record<PropertyReservationCtaPlacement, string> = {
    sidebar: css({mt: 1}),
    // shares one row with the lead and phone buttons of the contact bar
    contact_bar: contactBarRowButtonStyle
};

// the disabled look of the outlined button
const reservedStyle = css({
    borderColor: "var(--colors-gray-700)",
    color: "var(--colors-gray-700)",
    fill: "var(--colors-gray-700)",
    cursor: "not-allowed",
    _hover: {
        boxShadow: "none"
    }
});
import {css, cx} from "@panda/css";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {contactBarRowButtonStyle} from "../../atoms/contact_bar/contact_bar_row_button_style";
import {RESERVATION_PLACEMENT_CONFIG} from "../constants/reservation_placement_config";
import {ReservationCtaState} from "../types/ReservationCtaState";
import {ReservationPlacement} from "../types/ReservationPlacement";
import {ReservationCtaPlaceholder} from "./ReservationCtaPlaceholder";

export type PropertyReservationCtaPlacement = Extract<ReservationPlacement, "sidebar" | "contact_bar">;

interface IProps {
    ctaState: ReservationCtaState;
    placement: PropertyReservationCtaPlacement;
    size: IButtonSizePrimary;
    fullWidth?: boolean;
    className?: string;
    onStart: () => void;
}

export const PropertyReservationCtaView = (props: IProps) => {
    const {ctaState, placement, size, fullWidth, className, onStart} = props;

    if (ctaState === "hidden") {
        return null;
    }

    const placementClassName = cx(placementStyle[placement], className);

    if (ctaState === "pending") {
        // rendered the same way on the server and on the first client render, so the slot keeps its height until availability is known
        return <ReservationCtaPlaceholder size={size} fullWidth={fullWidth} className={placementClassName} />;
    }

    if (ctaState === "reserved") {
        // not natively disabled - it is the button the reservation modal was opened from, and the focus returns to it once the modal closes
        return (
            <Button
                variant="outlined_secondary"
                type="button"
                size={size}
                fullWidth={fullWidth}
                aria-disabled="true"
                className={cx(placementClassName, reservedStyle)}
                dataTestId={RP_RESERVATION_TEST_IDS.CTA_RESERVED}
            >
                Zarezerwowane
            </Button>
        );
    }

    const {cta} = RESERVATION_PLACEMENT_CONFIG[placement];

    return (
        <Button
            variant="filled_secondary"
            type="button"
            size={size}
            fullWidth={fullWidth}
            onClick={onStart}
            className={placementClassName}
            dataTestId={cta.testId}
        >
            {cta.label}
        </Button>
    );
};

// the slot owns its spacing, because it renders nothing for most properties
const placementStyle: Record<PropertyReservationCtaPlacement, string> = {
    sidebar: css({mt: 1}),
    // shares one row with the lead and phone buttons of the contact bar
    contact_bar: contactBarRowButtonStyle
};

// the disabled look of the outlined button
const reservedStyle = css({
    borderColor: "var(--colors-gray-700)",
    color: "var(--colors-gray-700)",
    fill: "var(--colors-gray-700)",
    cursor: "not-allowed",
    _hover: {
        boxShadow: "none"
    }
});
